module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-expressionless-217a42c9.svg";